import { useEffect, useState } from 'react';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import Avatar from 'react-avatar';
import { toast } from 'react-toastify';
import './People.scss';
import Icon from '@mdi/react';
import { mdiAccountOutline, mdiCheckDecagramOutline } from '@mdi/js';
import edit from '../../../../assets/images/calibration/edit.png';
import closeCircle from '../../../../assets/images/calibration/closeCircle.png';
import alertClose from '../../../../assets/images/calibration/alertClose.png';
import { UserAsyncAutocompleteSelect } from '../../../../components/Common';
import { fetchEmployeeSearchAutoComplete } from '../../../../store/apis/autocompleteService';
import { validatealiateEmployeeCodes } from '../../../../store/apis/calibrationService';
import { ImageFileUtil } from '../../../../utils';

function People({ isOpen, toggle, subjects, peoples, toggleSubjectForm }) {
  const [showAlert, setShowAlert] = useState(false);
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [selectedPeoples, setSelectedPeoples] = useState([]);
  const [rejectedSubjects, setRejectedSubjects] = useState([]);

  useEffect(() => {
    setShowAlert(false);
  }, [isOpen]);

  useEffect(() => {
    if (selectedPeoples?.length > 0) {
      toggle(selectedPeoples, selectedSubjects, true, true);
    }
  }, [selectedPeoples]);

  useEffect(() => {
    if (Array.isArray(subjects) && subjects.length > 0) {
      setSelectedSubjects(subjects);
    }
    if (Array.isArray(peoples)) {
      setSelectedPeoples(peoples);
    } else {
      setSelectedPeoples([]);
    }
  }, [peoples, subjects]);

  const validateSubjects = () => {
    const postData = {
      employeeCodes: selectedSubjects?.map(item => item.EmpCd),
    };
    validatealiateEmployeeCodes(postData)
      .then(res => {
        setRejectedSubjects(res.result);
        if (
          (res.result.length === selectedSubjects?.length &&
            res.result.find(rs => rs.IsValid === 'false')) ||
          res.result.length < selectedSubjects?.length
        ) {
          setShowAlert(true);
        } else {
          setShowAlert(false);
          toast.success('Validation successful! All subjects are valid.', {
            className: 'toast-success',
          });
          toggle(selectedPeoples, selectedSubjects, true, true);
        }
      })
      .catch(err => {
        toast.error(err?.message || 'Failed to validate subjects.', {
          className: 'toast-error',
        });
      });
  };

  const removeSelectedSubject = item => {
    setSelectedSubjects(prev => prev.filter(i => i.EmpCd !== item.EmpCd));
  };

  const removeSelectedPeople = item => {
    setSelectedPeoples(prev => prev.filter(i => i.EmpCd !== item.EmpCd));
  };

  const onSelectPeople = item => {
    if (
      item &&
      !selectedPeoples?.some(i => i.EmpCd === item.EmpCd) &&
      !selectedSubjects?.some(i => i.EmpCd === item.EmpCd)
    ) {
      setSelectedPeoples(prev => [...prev, item]);
    }
  };

  const onSelectSubject = item => {
    if (
      item &&
      !selectedSubjects?.some(i => i.EmpCd === item.EmpCd) &&
      !selectedPeoples?.some(i => i.EmpCd === item.EmpCd)
    ) {
      setSelectedSubjects(prev => [...prev, item]);
    }
  };

  // Helper to check if is rejected
  const isRejected = item => {
    if (!showAlert) return false;
    const rs = rejectedSubjects.find(r => r.EmpCd?.trim() === item.EmpCd);
    if (!rs) return true;
    return rs.IsValid === 'false';
  };

  // Get Display Order
  const displaySubjects = (selectedSubjects || [])
    .slice()
    .sort((a, b) => (isRejected(b) ? 1 : 0) - (isRejected(a) ? 1 : 0));

  const getImage = item => {
    if (item) {
      return ImageFileUtil.getEmployeeFilePath(item);
    }
    return null;
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => toggle(selectedPeoples, selectedSubjects, true)}
      backdrop={false}
      className="modal-people"
      modalClassName="main-modal-people"
    >
      <ModalHeader
        style={{ fontSize: '18px', fontWeight: '600' }}
        toggle={() => toggle(selectedPeoples, selectedSubjects, true)}
      >
        Selected People
        <div className="justify-content-end d-flex">
          <Button
            className="custom-success-outline-btn"
            onClick={() => validateSubjects()}
            outline
          >
            <Icon path={mdiCheckDecagramOutline} size={1} />{' '}
            <span>
              <strong>Validate</strong>
            </span>
          </Button>
          <Button
            className="no-outline"
            onClick={() => toggleSubjectForm(selectedSubjects)}
            outline
          >
            <img src={edit} alt="" />{' '}
            <span>
              <strong>Modify</strong>
            </span>
          </Button>
        </div>
      </ModalHeader>
      <ModalBody style={{ fontSize: '14px', fontWeight: '400' }}>
        {showAlert && (
          <div className="alert-box">
            <img src={alertClose} alt="" />

            <div className="alert-info">
              <div className="alert-title">
                <strong>Alert</strong>
              </div>
              <div className="alert-description">
                The following list of members have not reached the calibration
                stage
              </div>
            </div>
          </div>
        )}

        <div className="title">
          <strong>Participants ({selectedPeoples?.length})</strong>
        </div>
        <div className="search-input">
          <UserAsyncAutocompleteSelect
            autoCompleteFn={input =>
              fetchEmployeeSearchAutoComplete({
                prefixText: input,
              })
            }
            mappedFn={rawData =>
              rawData
                .filter(
                  ft =>
                    !selectedSubjects?.some(sb => sb.EmpCd === ft.EmpCd) &&
                    !selectedPeoples?.some(sp => sp.EmpCd === ft.EmpCd),
                )
                .map(item => ({
                  value: item?.EmpCd,
                  label: item?.Name,
                  Department: item.Department,
                  name: item?.Name,
                  Name: item?.Name,
                  EmpCd: item?.EmpCd,
                  code: item?.EmpCd,
                  image: item?.Imagefile,
                }))
            }
            onChange={selectedOption => onSelectPeople(selectedOption)}
            placeholder="Add Manager"
            isClearable
            isSearchable
            value=""
            inputIcon={
              <Icon path={mdiAccountOutline} size={0.8} color="#667085" />
            }
            rightKeyAssessor="code"
          />
        </div>
        <div className="items">
          {selectedPeoples?.map(item => (
            <div key={item.EmpCd} className="item">
              <div className="detail">
                <Avatar
                  name={item.Name || 'Unknown'}
                  size="32px"
                  color="#CFCBDC"
                  fgColor="#475467"
                  maxInitials={2}
                  style={{
                    fontSize: '14px',
                    fontWeight: '600',
                  }}
                  src={getImage(item?.image)}
                  round
                />
                <div className="info">
                  <div className="title">{item.EmpCd}</div>
                  <div className="sub-title-name">
                    <strong>{item.Name}</strong>
                  </div>
                </div>
              </div>
              <div className="department-title">
                <strong>{item.Department}</strong>
              </div>
              <Button
                className="no-outline"
                onClick={() => removeSelectedPeople(item)}
                outline
              >
                <img src={closeCircle} alt="" />
              </Button>
            </div>
          ))}
        </div>
        <div className="header-title">
          <strong>Subjects ({selectedSubjects?.length})</strong>
        </div>
        <div className="search-input">
          <UserAsyncAutocompleteSelect
            autoCompleteFn={input =>
              fetchEmployeeSearchAutoComplete({
                type: 'EMPLOYEE',
                prefixText: input,
              })
            }
            mappedFn={rawData =>
              rawData
                .filter(
                  ft =>
                    !selectedSubjects?.some(sb => sb.EmpCd === ft.EmpCd) &&
                    !selectedPeoples?.some(sp => sp.EmpCd === ft.EmpCd),
                )
                .map(item => ({
                  value: item?.EmpCd,
                  label: item?.Name,
                  Department: item.Department,
                  name: item?.Name,
                  Name: item?.Name,
                  EmpCd: item?.EmpCd,
                  code: item?.EmpCd,
                  image: item?.Imagefile,
                }))
            }
            onChange={selectedOption => onSelectSubject(selectedOption)}
            placeholder="Add Subject"
            isClearable
            isSearchable
            value=""
            inputIcon={
              <Icon path={mdiAccountOutline} size={0.8} color="#667085" />
            }
            rightKeyAssessor="code"
          />
        </div>
        <div className="items">
          {displaySubjects &&
            displaySubjects?.length > 0 &&
            displaySubjects?.map(item => (
              <div
                key={item.EmpCd}
                className={`item ${isRejected(item) ? 'rejected' : ''}`}
              >
                <div className="detail">
                  <Avatar
                    name={item.Name || 'Unknown'}
                    size="32px"
                    color="#CFCBDC"
                    fgColor="#475467"
                    maxInitials={2}
                    style={{
                      fontSize: '14px',
                      fontWeight: '600',
                    }}
                    src={getImage(item?.Imagefile)}
                    round
                  />
                  <div className="info">
                    <div className="title">{item.EmpCd}</div>
                    <div className="sub-title-name">
                      <strong>{item.Name}</strong>
                    </div>
                  </div>
                </div>
                <div className="department-title">
                  <strong>{item.Department}</strong>
                </div>
                <Button
                  onClick={() => removeSelectedSubject(item)}
                  className="no-outline"
                  outline
                >
                  <img src={closeCircle} alt="" />
                </Button>
              </div>
            ))}
        </div>
      </ModalBody>
    </Modal>
  );
}

export default People;
